import { PhoneCall, ScanSearch, Wrench, PackageCheck } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

const STEPS = [
  { icon: PhoneCall, title: "Devis express", desc: "Appelez-nous ou décrivez la panne en ligne : réponse en moins d'une heure ouvrée.", cta: "#devis" },
  { icon: ScanSearch, title: "Diagnostic 29 €", desc: "Nous contrôlons votre appareil en atelier à Saint-Pierre-en-Faucigny : 29 €, intégralement déduits si vous faites réparer.", cta: null },
  { icon: Wrench, title: "Réparation express", desc: "Le plus souvent en 30 à 60 minutes, sous vos yeux, avec des pièces testées.", cta: null },
  { icon: PackageCheck, title: "Restitution & garantie", desc: "Contrôle en 25 points, vos données intactes et 1 an de garantie pièces & main d'œuvre.", cta: null },
];

export default function HowItWorks() {
  return (
    <section id="processus" className="border-y border-line bg-ink py-24 lg:py-32">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8">
        <SectionHead
          tag="Comment ça marche"
          title={<>Quatre étapes, <span className="text-neon">zéro stress</span></>}
          sub="Un process simple et transparent, de votre premier appel à la restitution de votre appareil."
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => {
            const Inner = (
              <div
                className={`relative flex h-full flex-col rounded-2xl border p-7 transition-colors duration-300 ${
                  s.cta ? "cursor-pointer border-neon/40 bg-gradient-to-br from-neon/10 to-transparent hover:border-neon" : "border-line bg-night hover:border-neon/40"
                }`}
              >
                <span className="absolute right-6 top-5 font-display text-6xl font-black text-white/5">0{i + 1}</span>
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-neon/25 bg-neon/10 text-neon">
                  <s.icon size={22} />
                </span>
                <h3 className="mt-5 font-display text-xl font-bold uppercase tracking-tight text-white">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.desc}</p>
              </div>
            );
            return (
              <Reveal key={s.title} delay={i * 0.08}>
                {s.cta ? (
                  <button data-testid="process-step-1" onClick={() => scrollToSection(s.cta)} className="h-full w-full text-left">
                    {Inner}
                  </button>
                ) : (
                  Inner
                )}
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <p className="mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-slate-400">
            <strong className="font-semibold text-white">Suivi de votre réparation inclus :</strong> laissez votre email dans la demande de devis
            et créez votre espace client — connexion avec Google ou par email et mot de passe. Vous y voyez le statut de votre appareil en temps
            réel (reçue, en cours, terminée) et vous êtes prévenu par email à chaque changement d'étape.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
